/**
 * Noms des permissions tels que définis dans le back-end (format Permissions.{Entité}.{Action}).
 * Exemple back-end : "Permissions.Barillet.Read"
 */
export const PERMISSIONS = {
  /** Section admin SAM — visible dès qu'au moins une est accordée. */
  ADMIN: [
    'Permissions.Users.View',
    'Permissions.Roles.View',
    'Permissions.IncomingMessages.View',
    'Permissions.ScheduledTasks.View',
    'Permissions.OutgoingMessages.View',
  ] as const,
  PAIRING: [
    'Permissions.Appairages.Appairer',
    'Permissions.Appairages.Desappairer',
    'Permissions.Balises.ViewBalisesAvecPiece',
    'Permissions.DemandesApproTags.ManageDemandes',
  ] as const,
  EXPEDITION: {
    SEARCH: 'Permissions.DemandesExpeditions.Rechercher',
    PRIORITY: 'Permissions.DemandesExpeditions.GererPriorite',
  },
  ARTICLES: [
    'Permissions.Articles.View',
    'Permissions.Articles.Edit',
  ] as const,
  COMMENTS: [
    'Permissions.Commentaires.View',
    'Permissions.Commentaires.Edit',
  ] as const,
  INTERRUPT_REASONS: [
    'Permissions.InterruptReasons.View',
    'Permissions.InterruptReasons.Edit',
    'Permissions.InterruptReasons.ManagerInterruption',
  ] as const,
  PRIORITIES: [
    'Permissions.PriorisationParametrage.Rechercher',
    'Permissions.DemandesExpeditions.GererPriorite',
  ] as const,
} as const;

